module.exports = __webpack_public_path__ + "img/directPayHsbc.f57fcf7c.svg";